export enum ResizeHandleDirection {
    horizontal,
    vertical
}
